var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cell shrink" }, [
    _c(
      "div",
      {
        staticClass: "add-button pt-23",
        on: {
          click: function() {
            return _vm.$emit("click")
          }
        }
      },
      [_c("i", { staticClass: "fas fa-plus-circle" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49b9e0e2", { render: render, staticRenderFns: staticRenderFns })
  }
}